module.exports = __webpack_public_path__ + "static/media/muslim_friendly_BW.c6fa3844.png";